module.exports = __webpack_public_path__ + "media/assets/satellite-9bedf8ad2e2945bc1c4aaf1442a320c0.svg";